var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelSmsSm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 14,
  viewBox: "0 0 16 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "m10.522 4.425.228.005c3.626.154 6.082 3.307 4.914 6.307h.017a4 4 0 0 1-.234.505l.513 2.245c.058.252-.163.49-.459.49h-.021c-.047-.002-.253-.04-2.667-.458a6 6 0 0 1-2.326.457c-3.006-.003-5.45-2.144-5.45-4.775 0-2.71 2.592-4.897 5.713-4.77ZM5.49.932c2.115 0 4 1.065 4.902 2.675-3.994.056-6.986 3.297-6.153 6.75a6 6 0 0 1-1.083-.33l-2.597.449c-.327.056-.615-.196-.55-.482l.513-2.245A4.24 4.24 0 0 1 0 5.708C0 3.074 2.463.932 5.49.932"
})));
export default SvgChannelSmsSm;